import { createFileRoute } from '@tanstack/react-router';
import { getAuditLogsTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/relations/entities-to-logs/audit')({
  beforeLoad: () => getAuditLogsTitleContextSlice(),
});
